// extracted by mini-css-extract-plugin
module.exports = {"givePriority":"styles_givePriority__3DfFj","comparisonSelect":"styles_comparisonSelect__2Zb0S","input":"styles_input__3xzUN"};